import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { resolveFunnelUrlByMonetizationTest } from '@/helpers';
import { landingObjectRemoverConfig } from '@/data/landingConfig/landingObjectRemoverConfig';
import { MONETIZATION_TEST } from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ObjectRemover } from './schemaObject';

interface Props {}
const ObjectRemover: React.FC<Props> = () => {
	const funnelUrl = resolveFunnelUrlByMonetizationTest(
		{
			[MONETIZATION_TEST.NON_TIER_1]:
				GenerateLandingLinkService.funnelObjectRemoverV2,
		},
		GenerateLandingLinkService.funnelObjectRemover,
	);

	return (
		<>
			<AggregateSchema schema={schemaObject_ObjectRemover} />
			<LandingTemplate
				data={landingObjectRemoverConfig}
				funnelLinkService={funnelUrl}
			/>
		</>
	);
};

export default ObjectRemover;
